import styled from "styled-components";


export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 32px;
  align-items: center;

  ${props => props.theme.mediaQuerie.maxWidth.md} {
    flex-direction: column;
  }

  >span {
    margin: 0;
    width: 100%;
    margin-right: auto;
  }
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  ${props => props.theme.mediaQuerie.maxWidth.sm} {
    justify-content: space-between;
    width: 100%;
  }
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;


export const PlayersContainer = styled.div`
    display: flex;
    justify-content: center;
    gap: 16px;
    align-items: center;

    ${props => props.theme.mediaQuerie.maxWidth.sm} {
      justify-content: space-between;
      width: 100%;
    }
`;